import FormStep, { FormFields, FormStepControls } from "../FormStep";
import { authenticationFields } from "./fields";

export default function AuthenticationStep(props) {
  const { step, goNext, goPrev, isLoading, ...otherProps } = props;

  return (
    <FormStep
      step={step}
      title="Alright, one last step!"
      sideTitle={[
        "Join 1000+ happy creators",
        "Creators earned $4M+ last year",
        "50K+ users have paid so far",
      ]}
      sideDescription={[
        "Grow your passion with ease and confidence",
        "Increase your earnings up to 5x using qoohoo",
        "Monetise your audience on any platform",
      ]}
      sideImage={"/assets/illustrations/onboarding-4.svg"}
    >
      <FormFields fields={authenticationFields} {...otherProps} />
    </FormStep>
  );
}
